import React from 'react';
import { Link } from 'react-router-dom';

export function Header() {
  return (
    <header className="header">
      <Link to="/" className="header-logo" style={{ textDecoration: 'none', color: 'inherit' }}>
        <img src="/logo.jpeg" alt="Design Console" />
        <span>Design Console</span>
      </Link>
      
      <nav className="header-nav">
        <div className="nav-item">
          <span className="nav-label">Client:</span>
          <div className="nav-value">
            Amazon Inc. <span>▼</span>
          </div>
        </div>

        <div className="nav-item">
          <span className="nav-label">Market:</span>
          <div className="nav-value">
            United States <span>▼</span>
          </div>
        </div>

        <div className="nav-item">
          <span className="nav-label">Client brief:</span>
          <div className="nav-value">
            All <span>▼</span>
          </div>
        </div>
      </nav>

      <div className="header-plan">
        <span className="plan-label">Current Media Plan:</span>
        <span className="plan-name">Media Plan ABC</span>
        <button className="plan-button">Change Plan</button>
      </div>
    </header>
  );
} 